import * as React from "react";
import { observer } from "mobx-react";
import { Renderer } from "./Renderer";
import { defineCustomTags } from "../helpers";
defineCustomTags("sb-lazy-render");
//Todo to be extract on lib - https://jira.dkcorpit.com/browse/SB-24657
export class LazyRenderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.refRoot = React.createRef();
        this.state = {
            renderer: new Renderer(this.props.observerOptions || {})
        };
    }
    componentWillUnmount() {
        if (this.refRoot.current) {
            this.state.renderer.unRegisterDom(this.refRoot.current);
        }
    }
    componentDidMount() {
        if (this.refRoot.current) {
            this.state.renderer.registerDom(this.refRoot.current);
        }
    }
    getChildren() {
        return typeof this.props.contentCallback === "function" && this.state.renderer.isVisible
            ? this.props.contentCallback()
            : this.props.children;
    }
    render() {
        return (React.createElement("sb-lazy-render", { style: { minHeight: this.props.baseMinHeight }, ref: this.refRoot, "data-testid": "sb-lazy-render" }, this.state.renderer.isVisible && this.getChildren()));
    }
}
export const LazyRender = observer(LazyRenderComponent);
//# sourceMappingURL=LazyRender.js.map